import "./Membership.css";

import { useNavigate } from "react-router-dom";

import Navbar from "../../component/Navbar/Navbar";
import RegistrationSteps from "../../component/RegistrationSteps/RegistrationSteps";



/* ==========================================================
   MEMBERSHIP PAGE
========================================================== */

function Membership() {

  const navigate = useNavigate();


  /* ========================================================
     REGISTER NOW
     
     IMPORTANT:
     This starts a COMPLETELY NEW registration.

     It clears only registration/payment/membership data.
     It does NOT clear unrelated application data.
  ======================================================== */

  const handleRegisterNow = () => {

    console.log(
      "Starting new registration..."
    );


    /* ------------------------------------------------------
       Tell Registration.js that this is a NEW registration.
       
       Registration.js will:
       1. Detect this flag
       2. Clear old registration data
       3. Reset formData to {}
       4. Open Step 1
    ------------------------------------------------------ */

    sessionStorage.setItem(
      "startNewRegistration",
      "true"
    );


    /* ------------------------------------------------------
       Always start from Step 1
    ------------------------------------------------------ */

    navigate("/register");

  };


  return (

    <div className="membership-page">

      {/* ====================================================
          NAVBAR
      ==================================================== */}

      <Navbar />


      {/* ====================================================
          REGISTRATION STEPS
          
          Register Now button is handled here.
      ==================================================== */}

      <RegistrationSteps
        onRegisterNow={
          handleRegisterNow
        }
      />


      {/* ====================================================
          FOOTER
      ==================================================== */}


    </div>

  );

}


export default Membership;